import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Email Marketing Settings'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Email Marketing Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/settings/email-marketing',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
